export enum EPaths {
  Login = '/login',
  PasswordReset = '/passwordReset/:id',
  ExpiredPasswordReset = '/expiredPasswordReset',
  Dashboard = '/dashboard',
  Packages = '/packages',
  CruiseShips = '/cruiseShips',
  CruiseLines = '/cruiseLines',
  Places = '/places',
  Countries = '/countries',
  Cities = '/cities',
  Athletes = '/athletes',
  Disciplines = '/disciplines',
  HotSpots = '/hotSpots',
  Events = '/events',
  Destinations = '/destinations',
  Vouchers = '/vouchers',
  Customers = '/customers',
  SystemUsers = '/systemUsers',
  PromoCampaigns = '/promoCampaigns',
  Calculator = '/calculator',
  Notifications = '/notifications',
  VerifyEmail = '/notifications/verifyEmail',
  ResetPassword = '/notifications/resetPassword',
  ConfirmationSupport = '/notifications/confirmationSupport',
  InAppNotifications = '/notifications/inAppNotifications',
  CarrierStatus = '/carrierApiStatus',
  LegalLinks = '/legalLinks',
  MyProfile = '/myProfile',
  EmailVerification = '/emailVerification/:status',
  CompleteRegistration = '/completeRegistration',
  PaymentResult = '/payment',
  PartnerCodes = '/partnerCodes',
  NoPermissions = '/noPermissions',
  Receipt = '/receipt',
  PromoCodes = '/promocodes',
  Settings = '/settings',
}
